/**
 * ANWENDERTEXTE DES VERWALTUNGSBEREICHS UNTERNEHMEN, soweit sie mit dem Anzeigenamen (Migration 067, Entscheid 680)
 * dazugekommen sind.
 */
export const COMPANY_TEXT = {
  /** Beschriftung des Feldes, der Zeile im Detail und der Sammelmeldung. */
  displayName: "Anzeigename",
  /** Hilfetext unter dem Feld: wofür er steht und was ohne ihn gilt. */
  displayNameHelp: "Kurzer Name für den Unternehmensumschalter der Kopfleiste, zum Beispiel „Meine Energie“. "
    + "Bleibt das Feld leer, steht dort der Name des Unternehmens.",
} as const;
